import './modal-container.component.scss';

import { memo } from 'react';

const ModalContainer = props => {
  const {
    openModal,
    modalWidthType,
    hideClose,
    children
  } = props;
  const divStyle = { display: openModal ? 'block' : 'none' };

  const closeModal = (e) => {
    e.stopPropagation();
    props.closeModal();
  }

  return (
    <div
      className='custom-modal'
      style={divStyle}
    >
      <div
        className={`custom-modal-content ${ modalWidthType || 'modal-auto' }`}
      >
        <span
          className={`close ${hideClose ? 'd-none' : ''}`}
          onClick={ closeModal }>&times;
        </span>
        {openModal && children}
      </div>
    </div>
  );
}

export default memo(ModalContainer);